export const githubLink = "https://github.com/deniz-9";

export const linkedinLink =
  "https://www.linkedin.com/in/deniz-demir-a632b01a7/";
